module.exports = __webpack_public_path__ + "static/media/logo-menuVip.0657ee9d.png";